import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { HandHelping, Megaphone, ShieldCheck } from "lucide-react";

function Block({ icon: Icon, tint, title, children }) {
  return (
    <div className="flex gap-3">
      <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{ background: tint.bg, color: tint.text }}>
        <Icon size={20} />
      </div>
      <div>
        <h4 className="font-semibold text-[#0F1230]">{title}</h4>
        <p className="text-sm text-[#2A2E48]">{children}</p>
      </div>
    </div>
  );
}

export function HowItWorksDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="how-it-works-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Come funziona FYDATE</DialogTitle>
          <DialogDescription>La bacheca dei bisogni della tua zona.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-[#2A2E48]">FYDATE mette in contatto chi cerca un servizio con chi può offrirlo, vicino a te. Senza intermediari: scegli tu con chi parlare.</p>
          <Block icon={Megaphone} tint={{ bg: "#FFF6DA", text: "#141A3A" }} title="Ho bisogno">
            Scegli un'area (casa, mezzi, persona…), racconta in due parole di cosa hai bisogno e indica dove e quando. La richiesta resta online 15 giorni: ricevi disponibilità e scegli con chi parlare.
          </Block>
          <Block icon={HandHelping} tint={{ bg: "#FFF1E6", text: "#B8420A" }} title="Posso aiutare">
            Imposta la tua zona e guarda le richieste vicine. Ti rendi disponibile con un messaggio; il contatto avviene solo se il richiedente ti sceglie.
          </Block>
          <Block icon={ShieldCheck} tint={{ bg: "#FFFBEF", text: "#2E7D32" }} title="I tuoi dati sono al sicuro">
            Telefono ed email restano privati finché non decidi di condividerli in chat. Accordi, preventivi e pagamenti avvengono fuori dall'app.
          </Block>
        </div>
      </DialogContent>
    </Dialog>
  );
}
